@if(showFilter) {
<div class="search-top-level-container">
    <div class="row search-box g-0 search-box-gradient">
        <div class="col autocomplete-container" (click)="$event.stopPropagation()">
            @for (option of selectedOptions; track option; let i = $index) {

            @if (! searchTypes.isSearchShowSearchOptionGroup(option) && option.selected) {
            <div class="autocomplete-selected">
                <div class="top-level" [class.collapsed]="!option.active || option.type == searchOptionType.searchnumbers || option.type == searchOptionType.select">
                    @if ((option.type !== searchOptionType.switchoptiongroup && option.type !== searchOptionType.select && option.type !== searchOptionType.stringinput && option.type !== searchOptionType.searchnumbers) ||
                    (searchTypes.isSearchStringOption(option) && option.matchingOption)) {
                    <span class="row-toggle" (click)="toggleActiveOption(i)" [style.background-color]="option.colour">
                        <i-bs [name]="iconNames.ChevronDown" [@openClose]="option.active ? 'open' : 'closed'" class="d-inline-block"></i-bs>
                    </span>
                    }
                    @if (option.type == searchOptionType.switchoptiongroup || option.type == searchOptionType.searchnumbers || option.type === searchOptionType.select) {
                    <span class="row-toggle" [style.background-color]="option.colour">
                        <i-bs></i-bs>
                    </span>
                    }
                    <span class="option-name" (click)="toggleActiveOption(i)" [style.background-color]="option.colour">{{option.name}}&nbsp;</span>
                    @if (searchTypes.isSearchCheckboxOption(option)) {
                    <span class="option-summary" [style.background-color]="option.colour">
                        @if (option.numberChecked! > 1) {

                        ({{option.numberChecked}} of {{option.checkboxes.length}})

                        }
                        @if (option.numberChecked === 1) {

                        <span [innerHTML]="getFirstChecked(option.checkboxes)"></span>

                        }
                    </span>
                    }
                    @if (searchTypes.isSearchNumberRangeOption(option)) {
                    <span class="option-summary" [style.background-color]="option.colour">
                        @if (option.orPercent && option.orPercentOptions!.showPercent) {

                        {{option.orPercentOptions!.minValue | number}} &mdash; {{option.orPercentOptions!.maxValue | number }}%

                        } @else {

                        {{option.prefix}}{{option.minValue | number}}{{option.suffix}} &mdash; {{option.prefix}}{{option.maxValue | number }}{{option.suffix}}

                        }
                        @if (option.checkboxes?.length && option.numberChecked! > 0) {

                        + &hellip;

                        }
                    </span>
                    }
                    @if (searchTypes.isSearchDateRangeOption(option)) {
                    <span class="option-summary" [style.background-color]="option.colour">
                        <span class="badge text-bg-light">{{friendlyRange(option.minDate, option.maxDate)}} </span>
                        @if (option.relativeRange === '') {

                        {{option.minDate| date: 'mediumDate' }} - {{option.maxDate| date: 'mediumDate' }}

                        } @else {

                        <span>
                            @switch (option.relativeRange) {
                            @case ('1d') {
                            Last day
                            }
                            @case ('1w') {
                            Last week
                            }
                            @case ('1m') {
                            Last month
                            }
                            @case ('1y') {
                            Last year
                            }

                            @case ('ytd') {
                            Year To Date
                            }
                            }
                        </span>

                        }
                    </span>
                    }
                    @if (searchTypes.isSearchStringOption(option)) {
                    <span class="option-summary" [style.background-color]="option.colour">
                        <input type="text" class="form-control form-control-sm string-input-field ml-1" [(ngModel)]="$any(option).searchString" (keyup)="loadContent($event)" autocomplete="off">
                    </span>
                    }
                    @if (searchTypes.isSearchNumbersOption(option)) {
                    <span class="option-summary" [style.background-color]="option.colour">
                        <input type="text" class="form-control form-control-sm string-input-field ml-1" [(ngModel)]="$any(option).numberRange" (keyup)="loadContent($event)" autocomplete="off" placeholder="e.g 1,2-34">
                    </span>
                    }
                    @if (searchTypes.isSearchSelectOption(option)) {
                    <span class="option-summary" [style.background-color]="option.colour">
                        <select class="form-select-sm" [(ngModel)]="$any(option).selectedValue" (ngModelChange)="loadContent()">
                            @for (selectOption of option.selectOptions; track selectOption) {
                            <option [ngValue]="selectOption.optionValue">{{selectOption.label}}</option>
                            }
                        </select>
                    </span>
                    }
                    @if (searchTypes.isSearchMultiAutoCompleteOption(option)) {
                    <span class="option-summary" [style.background-color]="option.colour">
                        @if (option.required.length > 1) {

                        {{option.required.length}} parties

                        }
                        @if (option.required.length === 1) {

                        <span [innerHTML]="option.required[0].title"></span>
                        @if (option.required[0].filterby) {

                        ({{option.required[0].filterby}})

                        }

                        }
                    </span>
                    }
                    <button type="button" class="btn-close" (click)="topLevelSearchOptionDeSelect(i)"></button>
                </div>
                @if (option.active && option.type !== searchOptionType.searchnumbers && option.type !== searchOptionType.select) {
                <div [attr.id]="'collapse-' + option.id" class="collapse second-level show" [style.background]="'linear-gradient(var(--bs-body-bg), var(--bs-body-bg)) padding-box, linear-gradient(to right, ' + option.colour + ', #ccc) border-box'"
                    @optionGroupTrigger>
                    <div class="row g-0">
                        @if (searchTypes.isSearchCheckboxOption(option) || searchTypes.isSearchStringOption(option)) {
                        <ng-container *ngTemplateOutlet="showCheckboxesTemplate; context: { option }"></ng-container>
                        }
                        @if (option.type == searchOptionType.stringinput && searchTypes.isSearchStringOption(option) && option.matchingOptionTypes) {
                        <ul class="col list-unstyled">
                            @if (option.matchingOptionTypes.exactPhrase) {
                            <li class="form-check">
                                <input class="form-check-input ms-0 me-1" [name]="option.name" type="radio" [value]="'phrase'" [(ngModel)]="$any(option).matchingOption" [checked]="option.matchingOption === 'phrase'" id="{{ option.name + '_phrase' }}"
                                    (ngModelChange)="loadContent()">
                                <label class="form-check-label" for="{{ option.name + '_phrase' }}">Exact Phrase</label>
                            </li>
                            }
                            @if (option.matchingOptionTypes.allWords) {
                            <li class="form-check">
                                <input class="form-check-input ms-0 me-1" [name]="option.name" type="radio" [value]="'all'" [(ngModel)]="$any(option).matchingOption" [checked]="option.matchingOption === 'all'" id="{{ option.name + '_all' }}"
                                    (ngModelChange)="loadContent()">
                                <label class="form-check-label" for="{{ option.name + '_all' }}">All words</label>
                            </li>
                            }
                            @if (option.matchingOptionTypes.someWords) {
                            <li class="form-check">
                                <input class="form-check-input ms-0 me-1" [name]="option.name" type="radio" [value]="'some'" [(ngModel)]="$any(option).matchingOption" [checked]="option.matchingOption === 'some'" id="{{ option.name + '_some' }}"
                                    (ngModelChange)="loadContent()">
                                <label class="form-check-label" for="{{ option.name + '_some' }}">Any word</label>
                            </li>
                            }
                            @if (option.matchingOptionTypes.booleanMode) {
                            <li class="form-check">
                                <input class="form-check-input ms-0 me-1" [name]="option.name" type="radio" [value]="'boolean'" [(ngModel)]="$any(option).matchingOption" [checked]="option.matchingOption === 'boolean'"
                                    id="{{ option.name + '_boolean' }}" (ngModelChange)="loadContent()">
                                <label class="form-check-label" for="{{ option.name + '_boolean' }}">Boolean mode</label>
                            </li>
                            }
                        </ul>
                        }
                        @if (searchTypes.isSearchDateRangeOption(option)) {
                        <div>
                            <ul class="list-unstyled">
                                <li (click)="setDateRange( option, '1d')">
                                    <span class="checkbox-label w-100">
                                        <span class="badge text-bg-light">1d</span> Past Day
                                    </span>
                                </li>
                                <li (click)="setDateRange( option, 'wd')" class="date-range">
                                    <span class="checkbox-label w-100">
                                        <span class="badge text-bg-light">wd</span> Last Week Day
                                    </span>
                                </li>
                                <li (click)="setDateRange(option, '1w')">
                                    <span class="checkbox-label w-100">
                                        <span class="badge text-bg-light">1w</span> Past Week
                                    </span>
                                </li>
                                <li (click)="setDateRange(option, '1m')">
                                    <span class="checkbox-label w-100">
                                        <span class="badge text-bg-light">1m</span> Past Month
                                    </span>
                                </li>
                                <li (click)="setDateRange(option, '1y')">
                                    <span class="checkbox-label w-100">
                                        <span class="badge text-bg-light">1y</span> Past Year
                                    </span>
                                </li>
                                <li (click)="setDateRange(option, 'ytd')">
                                    <span class="checkbox-label w-100">
                                        <span class="badge text-bg-light">ytd</span> Year To Date
                                    </span>
                                </li>
                            </ul>
                            <div class="row">
                                <div class="col">
                                    <date-range [(minDate)]="$any(option).minDate" [(maxDate)]="$any(option).maxDate" (maxDateChange)="loadContentAfterDateChange($event, option, $any(option).maxDate)"
                                        (minDateChange)="loadContentAfterDateChange($event, option, $any(option).minDate)"></date-range>
                                </div>
                            </div>
                        </div>
                        }
                        @if (searchTypes.isSearchMultiAutoCompleteOption(option)) {
                        <div>
                            <ng-select [items]="option.items" bindLabel="title" [multiple]="true" placeholder="Search by name" [(ngModel)]="$any(option).required" [loading]="option.searching!" [searchFn]="multiAutocompleteNgSelectSearchFn"
                                (search)="multiAutocompleteSearch($event, option)" (change)="multiAutocompleteChange($event, option)" (add)="multiAutocompleteChange($event, option)" (clear)="multiAutocompleteClear(option)"
                                (remove)="multiAutocompleteRemove($event, option)" class="ng-select-multiautocomplete">
                                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                    <span class="ng-value-label" [innerHTML]="item.title">

                                    </span>
                                    @if (option.filter) {
                                    <select (mousedown)="$event.stopPropagation()" [(ngModel)]="$any(option).itemfilters![item.id]">
                                        @for (filter of option.filter; track filter) {
                                        <option [value]="filter">{{filter}}</option>
                                        }
                                        <option [value]=""></option>
                                    </select>
                                    }
                                    <span class="ng-value-icon right" (click)="clear(item)">×</span>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    <span [innerHTML]="item.title"></span>
                                </ng-template>
                            </ng-select>
                        </div>
                        }
                        @if (searchTypes.isSearchNumberRangeOption(option)) {
                        <div>
                            @if (option.orPercent) {
                            <div class="row justify-content-center mb-2 g-0">
                                <div class="col-auto text-nowrap">
                                    {{option.prefix}}&nbsp;
                                </div>
                                <div class="col-auto text-nowrap">
                                    <div class="form-switch">
                                        <input class="form-check-input" id="checkbox-{{option.id}}-or" type="checkbox" [(ngModel)]="$any(option).orPercentOptions!.showPercent">
                                    </div>
                                </div>
                                <div class="col-auto text-nowrap">
                                    &nbsp;%
                                </div>
                            </div>
                            }
                            @if (option.orPercent && option.orPercentOptions!.showPercent) {

                            <div class="row justify-content-center g-0">
                                <div class="col-auto">
                                    <div class="form-inline">
                                        <input type="text" class="form-control form-control-sm small-number" [(ngModel)]="$any(option).orPercentOptions!.minValue" (input)="loadContent()">
                                        <label>%</label>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="form-inline">
                                        <label>&nbsp;&mdash;&nbsp;</label>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="form-inline">
                                        <input type="text" class="form-control form-control-sm small-number" [(ngModel)]="$any(option).orPercentOptions!.maxValue" (input)="loadContent()">
                                        <label>%</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col custom-slider">
                                    <ngx-slider class="custom-slider" [(value)]="$any(option).orPercentOptions!.minValue" [(highValue)]="$any(option).orPercentOptions!.maxValue" [options]="{ floor: 0, ceil: 100, logScale: false,}"
                                        (valueChange)="loadContent()"></ngx-slider>
                                </div>
                            </div>

                            } @else {

                            <div class="row justify-content-center g-0">
                                <div class="col-auto">
                                    <div class="form-inline">
                                        <label>{{option.prefix}}</label>
                                        <input type="text" class="form-control form-control-sm larger-number" [(ngModel)]="$any(option).minValue" (input)="loadContent($event)">
                                        <label>{{option.suffix}}</label>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="form-inline">
                                        <label>&nbsp;&mdash;&nbsp;</label>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="form-inline">
                                        <label>{{option.prefix}}</label>
                                        <input type="text" class="form-control form-control-sm larger-number" [(ngModel)]="$any(option).maxValue" (input)="loadContent($event)">
                                        <label>{{option.suffix}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col custom-slider">
                                    <ngx-slider class="custom-slider" [(value)]="$any(option).minValue" [(highValue)]="$any(option).maxValue" [options]="option.options" (valueChange)="loadContent()"></ngx-slider>
                                </div>
                            </div>

                            }
                            @if (option.checkboxes?.length) {
                            <div class="row justify-content-center">
                                <div class="col-auto text-nowrap">
                                    @for (checkbox of option.checkboxes; track checkbox; let i = $index) {
                                    <div class="form-switch">
                                        <input class="form-check-input" id="checkbox-{{option.id}}-{{i}}" type="checkbox" [value]="checkbox.value || checkbox.name" [checked]="checkbox.checked" (change)="toggleCheckBox(checkbox, option)">
                                        <label class="form-check-label" for="checkbox-{{option.id}}-{{i}}">&nbsp;{{checkbox.name}}</label>
                                    </div>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                        }
                    </div>
                </div>
                }
            </div>
            }

            }
            <div class="form-group search-input">
                <input #input id="autocomplete-input" type="text" class="form-control autocomplete" (focus)="setupToShowAutoCompleteOptions(input.value)" (keyup)="setupToShowAutoCompleteOptions(input.value)" (paste)="handlePaste($event)"
                    placeholder="{{filterPlaceholder}}" [(ngModel)]="autocompleteText" (keydown.enter)="acceptText()" autocomplete="off">
                <div #autocompleteoptions class="autocomplete-options row" [style.left.px]="leftPosition">
                    @for (optionGroup of topLevelSearchOptionGroups; track optionGroup) {

                    @if (optionGroup.visible && allDependenciesMetForSearchOptionGroup(optionGroup) && optionGroupHasSomeVisibleElements(optionGroup)) {
                    <div class="option-group-column col">
                        <div class="option-group-header text-center" [style.color]="optionGroup.colour">
                            Filter by {{optionGroup.groupName}}
                        </div>
                        <ul>
                            @for (option of optionGroup.options; track option) {

                            @if (option.visible && !option.selected && allDependenciesMet(option)) {
                            <li (click)="topLevelSearchOptionSelect(option)">
                                <i-bs [name]="option.icon"></i-bs>
                                <span class="name">{{option.name}}</span>
                                @if (searchTypes.isSearchStringOption(option) && option.searchString) {
                                <span>&nbsp;contains&nbsp;{{option.searchString}}</span>
                                }
                                @if (searchTypes.isSearchNumbersOption(option) && option.numberRange) {
                                <span>&nbsp;{{option.numberRange}}</span>
                                }
                                @if (searchTypes.isSearchMultiAutoCompleteOption(option)) {
                                <div>
                                    @if (option.searching) {
                                    <div class="spinner-border spinner-border-sm"></div>
                                    }
                                    @if (option.items.length) {
                                    <ul class="matching-options">
                                        @for (item of option.items; track item) {

                                        <li (click)="topLevelSearchOptionSelect(option, null, item)">
                                            <div class="matched-option">
                                                <span class="link-arrow"></span><span [innerHTML]="item.title"></span>
                                            </div>
                                        </li>

                                        }
                                    </ul>
                                    }
                                </div>
                                }
                                @if (searchTypes.isSearchCheckboxOption(option) && autocompleteText.length) {
                                <ul class="matching-options">
                                    @for (checkbox of option.checkboxes; track checkbox) {

                                    @if (checkboxDependenciesMet(checkbox, autocompleteText)) {
                                    <li (click)="topLevelSearchOptionSelect(option, checkbox)">
                                        <div class="matched-option">
                                            <span class="link-arrow"></span>{{checkbox.name}}
                                        </div>
                                    </li>
                                    }

                                    }
                                </ul>
                                }
                            </li>
                            }

                            }
                        </ul>
                    </div>
                    }

                    }
                    <div class="notch"></div>
                </div>
            </div>
        </div>
        @if ((userState$ | async)?.user?.ipuser === false) {
        <div class="save-container col-auto">
            @if (allowSearchesToBeSaved && selectedOptions.length > 0) {
            <div class="autocomplete-selected" (click)="saveSearch()">
                <div class="top-level">
                    <span class="option-name" class="row-toggle">
                        <i-bs [name]="iconNames.Save"></i-bs> {{saveSearchesText}}
                    </span>
                </div>
            </div>
            }
        </div>
        }
        @if (selectedOptions.length > 0) {
        <button class="btn col-auto btn-close clear-search" (click)="clearSearch()"></button>
        }
    </div>
</div>
}

<ng-template #showCheckboxesTemplate let-option="option" let-indent="indent">
    @if (option.checkboxes?.length) {
    <ul class="col list-unstyled {{indent}}" [style.columns]="numberOfColumns(option.checkboxes?.length)">
        @for (checkbox of option.checkboxes; track checkbox) {

        @if (checkboxDependenciesMet(checkbox)) {
        <li>
            <input class="checkbox-option" type="checkbox" [value]="checkbox.value || checkbox.name" [checked]="checkbox.checked" (change)="toggleCheckBox(checkbox, option)">
            <div class="checkbox-label" (click)="changeCheckboxes(checkbox, option)">
                <span class="checkbox-name text-nowrap">
                    {{checkbox.name}}
                    <span style="visibility: hidden;">Toggle</span>
                </span>
                <span class="only-all">
                    @if (checkbox.checked && option.numberChecked === 1) {

                    All

                    } @else {
                    Only
                    }
                </span>
                <span class="toggle">Toggle</span>
            </div>
        </li>
        @if (showCheckboxConditionalOptions(option, checkbox)) {
        <li class="no-hover">
            <ng-container *ngTemplateOutlet="showCheckboxesTemplate; context: { option: checkbox.conditionalOptions, indent: 'ms-2' }"></ng-container>
        </li>
        }
        }

        }
    </ul>
    }

</ng-template>

<ng-template #companyChooser let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{pastedChooserHeader}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        @if (pasteChooserLoading) {
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
            </div>
        </div>
        }
        @if (pastedChoices$ | async; as choices) {
        @for (choice of choices; track choice.id; ; let i = $index) {
            <form>
                <div class="row my-1">
                    <div class="col">
                        <select class="form-select" [(ngModel)]="pastedChoices[i].match" [ngModelOptions]="{standalone: true}">
                            <option [ngValue]="'contains'">Contains "{{choice.id}}"</option>
                            <option [ngValue]="'exact'">{{choice.id}}</option>
                        </select>
                    </div>
                    <div class="col-auto">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="pastedChoices[i].checked" [ngModelOptions]="{standalone: true}">
                    </div>
                </div>
            </form>
        }
        }

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.close('Save click')">Save</button>
    </div>
</ng-template>